import React, { useContext, useEffect } from 'react'
import SVG from 'react-inlinesvg'
import previousIcon from '../../../images/previous.svg'
import { TicketsAppContext } from '../context/tickets-app-context'
import { memoize } from 'lodash-es'
import { STEPS } from '../helpers/steps'
import { inManualUpdate } from '../../shared/helpers/logic'

const fromEventEntry = (event, step, selectedDate) => {
  if (event && event.managedCapacity) {
    return event && step === STEPS.PARTY
  } else {
    return event && step === STEPS.DATETICKETS
  }
}

const findEvent = memoize((productId, events) => {
  return events && events.find(event => event.productId === productId)
})

const goBack = (back, step, event) => _ => {
  if (fromEventEntry(event, step) || (inManualUpdate && step === STEPS.PARTY)) {
    return history.back()
  }
  back()
}

const title = (event, step, selectedDate) => {
  let text = 'Back'
  let eventTitle = event ? event.name : ''
  if (fromEventEntry(event, step, selectedDate)) {
    text = `Back to ${eventTitle} Event Page`
  }
  return text
}

const renderBackLink = () => {
  const {
    actions: { back },
    step,
    fromEvent,
    events,
    selectedDate
  } = useContext(TicketsAppContext)
  const event = findEvent(Number(fromEvent), events.events)
  if (step > STEPS.DATETICKETS || (fromEvent && step === STEPS.DATETICKETS)) {
    return (
      <button
        onClick={goBack(back, step, event)}
        className="back-button"
      >
        <SVG
          src={previousIcon}
          width="7"
          height="12"
          aria-hidden="true"
        />
        <span>{title(event, step, selectedDate)}</span>
      </button>
    )
  }
}

function StepHeader({ heading }) {
  useEffect(() => {
    setTimeout(() => {
      document.getElementById('step-header').focus()
    }, 100)
  }, [])
  return (
    <div
      className={'page-header-container divider-2-green'}
    >
      {renderBackLink()}
      <h1
        id="step-header"
        tabIndex="-1"
      >
        {heading}
      </h1>
    </div>
  )
}

export default StepHeader
